import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

export const StyledCarContainer = styled.div`
	max-width: max-content;
	${customBreakPoint(500, 'max-width: 444px;')}
	justify-content: stretch;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	overflow: hidden;
`;

export const StyledResult = styled.div`
	max-width: 444px;
	width: 100%;
	display: flex;
	flex-direction: column;
	padding-bottom: 12px;
	float: left;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;

	.diff-group {
		height: 120px;
	}

	ol {
		margin-top: 2px;
		list-style: decimal;
		margin-left: 1rem;

		li {
			padding: 0.3rem 0;
		}
	}
`;
